import { render, staticRenderFns } from "./Infobanner.vue?vue&type=template&id=12d79c25&scoped=true&"
import script from "./Infobanner.vue?vue&type=script&lang=js&"
export * from "./Infobanner.vue?vue&type=script&lang=js&"
import style0 from "./Infobanner.vue?vue&type=style&index=0&id=12d79c25&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d79c25",
  null
  
)

export default component.exports